import { useEffect, useRef } from "react";

const PickupLocationField = ({
  instanceId,
  value = "",
  onChange,
  onBlur,
  hasError = false,
  disabled = false,
  mapsReady = false,
  placeholder = "Start typing an address...",
}) => {
  const inputRef = useRef(null);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (!mapsReady || !inputRef.current || !window.google?.maps?.places) {
      return undefined;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      fields: ["geometry", "name", "formatted_address", "place_id"],
    });

    const listener = autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      const name =
        place.formatted_address ||
        place.name ||
        inputRef.current?.value ||
        "";
      const lat = place.geometry?.location?.lat?.();
      const lng = place.geometry?.location?.lng?.();

      onChangeRef.current({
        name: String(name).trim(),
        latitude: lat != null ? lat : "",
        longitude: lng != null ? lng : "",
        place_id: place.place_id ?? null,
      });
    });

    return () => {
      window.google.maps.event.removeListener(listener);
    };
  }, [mapsReady, instanceId]);

  const inputClasses = `w-full px-3 py-2 border ${
    hasError ? "border-red-500" : "border-gray-300"
  } rounded-lg focus:outline-none focus:border-primary text-sm shadow-sm transition-all`;

  return (
    <input
      key={instanceId}
      ref={inputRef}
      id={`pickup-location-${instanceId}`}
      type="text"
      defaultValue={value}
      disabled={disabled}
      placeholder={placeholder}
      onBlur={onBlur}
      onChange={(e) => {
        onChangeRef.current({
          name: e.target.value,
          latitude: "",
          longitude: "",
          place_id: null,
        });
      }}
      className={inputClasses}
      autoComplete="off"
    />
  );
};

export default PickupLocationField;
